/**
 *
 * @param theme
 */
/**
 * Component overrides for theme
 * @param theme - Material-UI theme object
 * @returns Theme component overrides configuration
 */
export default function Button(theme: any): any {
  const disabledStyle = {
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey[200],
    },
  };

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 500,
          textTransform: "none",
          transition: "transform .2s",
          transform: "translateZ(0)",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "none",
          },
        },
        contained: {
          ...disabledStyle,
        },
        outlined: {
          ...disabledStyle,
        },
      },
    },
  };
}
